/**
 * RitualTagsList Component (TagsSection)
 * Displays tags as wrapped badge chips
 */

import { TagChip } from "@/components/shared/TagChip"

export interface RitualTag {
  id: string
  tagText: string
  isSystem?: boolean
}

interface RitualTagsListProps {
  tags: RitualTag[] | string[]
}

function isRitualTag(tag: string | RitualTag): tag is RitualTag {
  return typeof tag === "object" && "tagText" in tag
}

export function RitualTagsList({ tags }: RitualTagsListProps) {
  if (tags.length === 0) return null

  return (
    <div className="rounded-lg">
      <div className="flex flex-wrap gap-2.5">
        {tags.map((tag, index) => {
          const tagText = isRitualTag(tag) ? tag.tagText : tag
          return (
            <TagChip
              key={`${tagText}-${index}`}
              tag={tagText}
              tab="rituals"
              className="p-2.5 rounded-lg border-primary text-primary leading-5"
            />
          )
        })}
      </div>
    </div>
  )
}
